import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export type AuthorizationRequest = {
  telefone?: string;
  dadosAutorizacao?: {
    dataAutorizacao?: string;
    latitude?: string;
    longitude?: string;
    navegadorUserAgent?: string;
  };
};

export type AuthorizationResponse = {
  processo: {
    id: number;
    mensagem: string;
  };
  proposta: { id: number } | null;
};

export async function postAuthorization(
  preTransactionId: string,
  payload: AuthorizationRequest = {},
): Promise<AuthorizationResponse> {
  const { data } = await httpClient
    .post<AuthorizationResponse>(
      `/crefaz-clt/${preTransactionId}/authorization`,
      payload,
      { journey: PartnerType.CREFAZ_CLT },
    )
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
